/**
 * @description 生成随机字符串
 * @param {number} length
 */
export function getRandomString(length = 10) {
  const str = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += str.charAt(Math.floor(Math.random() * str.length))
  }
  return result
}
